import { axiosInstance } from "../../services/axiosInstace";
import { GET_AGENT_ACCOUNT } from "../types/agentAccountType";
import store from "../store";

const dispatch = store.dispatch;

export const getAgentAccount = async (requestParams) => {
  try {
    // dispatch(asyncActionStart())
    const res = await axiosInstance.get(`/api/tms/portal/agent/account`, {
      params: {
        ...requestParams,
      },
    });
    dispatch({
      type: GET_AGENT_ACCOUNT,
      payload: res.data.data.content,
    });
    // dispatch(asyncActionFinish())
  } catch (err) {
    console.log(err);
  }
};
